import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { tomos } from '../../data/tomos';
export function Tomos() {
  return <section className="bg-paper py-10 sm:py-14" data-id="element-191" data-mp="7wt6aivc8xuq">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-192" data-mp="7z5uvevlq6gr">
        <SectionTag icon="📖" tone="primary" data-id="element-193" data-mp="cuupr4woez6q">
          Colección completa
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-194" data-mp="3bf37rvl5dsis">
          6 Tomos organizados por aplicación
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-5 px-4 sm:grid-cols-2 sm:px-6" data-id="element-195" data-mp="3lbfzwp11nybf">
        {tomos.map((tomo, i) => <m.div key={tomo.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col rounded-2xl border-2 border-gold/40 bg-white p-6 shadow-card-light" data-id="element-196" data-mp="3qc3svg8u2p8a" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-197" data-mp="1ctnyrsjnuwmp">
              <span className="font-heading text-3xl font-bold text-accent" data-id="element-198" data-mp="1cugvs1sti7rn">{tomo.n}</span>
              <span className="rounded-full bg-primary/5 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary" data-id="element-199" data-mp="18qj1c4eftl4x">
                Tomo {tomo.n}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-primary sm:text-xl" data-id="element-200" data-mp="yvh7iv97vuw0">
              {tomo.title}
            </h3>
            <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-gold" data-id="element-201" data-mp="p3tlxazcd82g">{tomo.subtitle}</p>
            <p className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-202" data-mp="l31cohqgz366">{tomo.description}</p>
            <ul className="mt-4 space-y-2" data-id="element-203" data-mp="g358ahdv19q3">
              {tomo.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink" data-id="element-204" data-mp="b4bt8kixdant">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-205" data-mp="1gpuhqxmehjl" />
                  <span data-id="element-206" data-mp="1j2hiii8ji3i">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}